<div
  class="full-bg bg translate-top-most"
  id="overlay"
  *ngIf="data.isPopUpVisible && isMenuLoaded"
>
  <!-- [ngStyle]="{visibility: (data.isPopUpVisible && isMenuLoaded)?'visible':'hidden'}" -->
  <div
    class="betlimit_popup_orientation"
    [ngClass]="'betlimit_popup_orientation_' + isportrait"
    [ngStyle]="{
      position: 'absolute',
      width: (isportrait ? 720 : 1280) * scaleR.scaleX + 'px',
      height: (isportrait ? 1280 : 720) * scaleR.scaleX + 'px',
      left: (isportrait ? -279 : 0) * scaleR.scaleX + 'px',
      top: (isportrait ? 241 : 0) * scaleR.scaleX + 'px'
    }"
  >
    <div>
      <div
        class="translate-top-most"
        [resizeDom]="{
          stageWidth: 1280,
          stageHeight: 720,
          stageLeft: 0,
          stageTop: 0,
          stageZ: 1000,
          position: 'absolute',
          overflow: 'visible'
        }"
      >
        <img
          class="limit-bg"
          src="./assets/images/common/queued_player_mode_new_table_place_your_bets@2x.webp"
        />
        <img
          class="select-bg select-bg-1"
          [ngStyle]="{ opacity: optionOver == 1 ? 1 : 0 }"
          [appImageSprite]="'felt_select_green'"
          [params]="menu_icons"
        />
        <img
          class="select-bg select-bg-2"
          [ngStyle]="{ opacity: optionOver == 2 ? 1 : 0 }"
          [appImageSprite]="'felt_select_green'"
          [params]="menu_icons"
        />
        <img
          class="select-bg select-bg-3"
          [ngStyle]="{ opacity: optionOver == 3 ? 1 : 0 }"
          [appImageSprite]="'felt_select_green'"
          [params]="menu_icons"
        />
        <img
          class="select-bg select-bg-4"
          [ngStyle]="{ opacity: optionOver == 4 ? 1 : 0 }"
          [appImageSprite]="'felt_select_green'"
          [params]="menu_icons"
        />
        <img
          class="select-bg select-bg-5"
          [ngStyle]="{ opacity: optionOver == 5 ? 1 : 0 }"
          [appImageSprite]="'felt_select_green'"
          [params]="menu_icons"
        />
        <!--   <img class="select-bg select-bg-6" [ngStyle]="{'opacity': (optionOver == 0)?1:1}" [src]="getImageFromMenuSprite('felt_select_green')">
 -->
        <img
          class="select-bg select-bg-7"
          [ngStyle]="{ opacity: optionOver == 6 ? 1 : 0 }"
          [appImageSprite]="'felt_select_green'"
          [params]="menu_icons"
        />
        <div
          class="limits limit-1"
          [resizeText]="data.userCurrency == 'MOP' ? 20 : 24"
        >
          {{ betLimits[0].min | usercurrency | currencysymbol }}-{{
            betLimits[0].max | usercurrency | currencysymbol
          }}
        </div>
        <div
          class="limits limit-2"
          [resizeText]="data.userCurrency == 'MOP' ? 20 : 24"
        >
          {{ betLimits[1].min | usercurrency | currencysymbol }}-{{
            betLimits[1].max | usercurrency | currencysymbol
          }}
        </div>
        <div
          class="limits limit-3"
          [resizeText]="data.userCurrency == 'MOP' ? 20 : 24"
        >
          {{ betLimits[2].min | usercurrency | currencysymbol }}-{{
            betLimits[2].max | usercurrency | currencysymbol
          }}
        </div>
        <div
          class="limits limit-4"
          [resizeText]="data.userCurrency == 'MOP' ? 20 : 24"
        >
          {{ betLimits[3].min | usercurrency | currencysymbol }}-{{
            betLimits[3].max | usercurrency | currencysymbol
          }}
        </div>
        <div
          class="limits limit-5"
          [resizeText]="data.userCurrency == 'MOP' ? 20 : 24"
        >
          {{ betLimits[4].min | usercurrency | currencysymbol }}-{{
            betLimits[4].max | usercurrency | currencysymbol
          }}
        </div>

        <div
          class="option-overlay overlay-1"
          (click)="onOptionSelect(betLimits[0].betlimitid)"
          (mouseover)="onOptionOver(1)"
          (mouseout)="onOptionOut(1)"
        ></div>
        <div
          class="option-overlay overlay-2"
          (click)="onOptionSelect(betLimits[1].betlimitid)"
          (mouseover)="onOptionOver(2)"
          (mouseout)="onOptionOut(2)"
        ></div>
        <div
          class="option-overlay overlay-3"
          (click)="onOptionSelect(betLimits[2].betlimitid)"
          (mouseover)="onOptionOver(3)"
          (mouseout)="onOptionOut(3)"
        ></div>
        <div
          class="option-overlay overlay-4"
          (click)="onOptionSelect(betLimits[3].betlimitid)"
          (mouseover)="onOptionOver(4)"
          (mouseout)="onOptionOut(4)"
        ></div>
        <div
          class="option-overlay overlay-5"
          (click)="onOptionSelect(betLimits[4].betlimitid)"
          (mouseover)="onOptionOver(5)"
          (mouseout)="onOptionOut(5)"
        ></div>
      </div>
      <div
        [resizeDom]="{
          stageWidth: 517,
          stageHeight: 105,
          stageLeft: 384,
          stageTop: 95,
          stageZ: 1000,
          position: 'absolute',
          overflow: 'visible'
        }"
        class="translate-top-most"
      >
        <div
          class="place-your-bets-header lang-specific-quicktips-font-family"
          [resizeText]="betLimitDesktop.betLimitHeaderFontSize"
        >
          <img
            class="liveDealer_icon"
            [ngStyle]="{
              'padding-right': 21 * scaleR.scaleX + 'px',
              width: 77 * scaleR.scaleX + 'px',
              height: 32 * scaleR.scaleX + 'px'
            }"
            [appImageSprite]="'livedealer'"
            [params]="common_icons"
          />{{ 'LANG00128' | translate }}
        </div>
        <div
          class="new-table-header lang-specific-quicktips-font-family"
          [resizeText]="betLimitDesktop.betLimitHeaderFontSize"
        >
          {{ 'LANG00472' | translate }}
        </div>
      </div>
      <div
        [resizeDom]="{
          stageWidth: 517,
          stageHeight: 105,
          stageLeft: 384,
          stageTop: 460,
          stageZ: 1000,
          position: 'absolute',
          overflow: 'visible'
        }"
        class="translate-top-most"
      >
        <div
          class="continue-header lang-specific-quicktips-font-family"
          [resizeText]="betLimitDesktop.betLimitHeaderFontSize"
        >
          {{ 'LANG00629' | translate }}
        </div>
        <div
          class="observation-mode lang-specific-quicktips-font-family"
          [resizeText]="betLimitDesktop.betLimitContentFontSize"
        >
          {{ 'LANG00800' | translate }}
        </div>
        <div
          class="option-overlay overlay-7"
          (click)="onOptionSelect('backtogame')"
          (mouseover)="onOptionOver('6')"
          (mouseout)="onOptionOut('6')"
        ></div>
      </div>
    </div>
  </div>
</div>
